
// region JS Imports

// region External Modules
import $ from "jquery"

import { EventEmitter } from "events"

import Swiper from "swiper"
import { Navigation, Manipulation, FreeMode } from "swiper/modules"
// endregion External Modules

// region Private Modules
// endregion Private Modules

// region Public Components
import ListingsRowCardDefault from "concepts/listings/row/card/default"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope: string

  swiper: string

  swiper_prev_button: string
  swiper_next_button: string
}
interface InputSelector {
  scope?: string

  swiper?: string

  swiper_prev_button?: string
  swiper_next_button?: string
}
const DEFAULT_SELECTOR = {
  scope: ".page--building-level-real-estate-transactions-page--desktop--sale-listings-section",

  swiper: ".page--building-level-real-estate-transactions-page--desktop--sale-listings-swiper",

  swiper_prev_button: ".swiper-button-prev",
  swiper_next_button: ".swiper-button-next",
}


class SaleListings extends EventEmitter {
  protected selector: Selector

  protected $scope: JQuery

  protected $swiper: JQuery

  protected $swiper_prev_button: JQuery
  protected $swiper_next_button: JQuery

  protected swiper: Swiper


  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = $(this.selector.scope)

    this.$swiper = this.$scope.find(this.selector.swiper)

    this.$swiper_next_button = this.$scope.find(this.selector.swiper_next_button)
    this.$swiper_prev_button = this.$scope.find(this.selector.swiper_prev_button)

    this.swiper = new Swiper(this.$swiper[0], {
      modules:              [ Navigation, Manipulation, FreeMode ],
      spaceBetween:         30,
      direction:            "horizontal",
      allowTouchMove:       true,
      slidesPerView:        3.5,
      centeredSlides:       true,
      centeredSlidesBounds: true,
      navigation:           {
        nextEl: this.$swiper_next_button[0],
        prevEl: this.$swiper_prev_button[0],
      },
    })

    this.created()
  }

  protected created() {
    ListingsRowCardDefault.init()
  }

}


const Factory = {
  _instance: null as null | SaleListings,
  instance(selector?: InputSelector){
    if (this._instance !== null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new SaleListings(selector)
  },
}

export {
  Factory,
  SaleListings,
}
